/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import type { LazyModal } from '@freelancer/ui/modal';

export const componentsModals: { [k: string]: LazyModal } = {
  AiCloseModal: {
    loadComponent: () =>
      import('@freelancer/components/ai-modal/ai-close-modal.component').then(
        m => m.AiCloseModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/components/ai-modal/ai-close-modal.module').then(
        m => m.AiCloseModalModule,
      ),
  },
  AiModal: {
    loadComponent: () =>
      import('@freelancer/components/ai-modal/ai-modal.component').then(
        m => m.AiModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/components/ai-modal/ai-modal.module').then(
        m => m.AiModalModule,
      ),
  },
  CustomBannerPopUpModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/custom-banner/pop-up-modal/custom-banner-pop-up-modal.component'
      ).then(m => m.CustomBannerPopUpModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/custom-banner/pop-up-modal/custom-banner-pop-up-modal.module'
      ).then(m => m.CustomBannerPopUpModalModule),
  },
  UserFeedbackModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.component'
      ).then(m => m.UserFeedbackModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.module'
      ).then(m => m.UserFeedbackModalModule),
  },
};
